<template>
    <section>
        <h1 class="">В доступе отказано</h1>
    </section>
</template>

<script>
    export default {
        name: "permissionDenied"
    }
</script>

<style scoped>

</style>